module.exports = __webpack_public_path__ + "static/media/gasolina.0746be38.svg";